<template>
  <div class="history">
    <!-- card -->
    <el-card class="box-card">
      <div slot="header">
        <el-row style="display: flex; align-items: center">
          <el-col :span="4">
            <span>{{ pageTitle }}</span>
          </el-col>
          <el-col :span="11"> &nbsp; </el-col>
          <!-- 时间选择 -->
          <el-col :span="8">
            <el-date-picker
              v-if="type !== '5'"
              v-model="pickerDate"
              value-format="yyyy-MM-dd"
              format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :editable="false"
              unlink-panels
              :picker-options="pickerOptions"
              @change="handleDateChange"
            >
            </el-date-picker>
            <el-date-picker
              v-if="type === '5'"
              v-model="monthPicker"
              value-format="yyyy-MM"
              format="yyyy-MM"
              type="month"
              placeholder="选择月份"
              @change="handleMonthChange"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="1">
            <el-button
              v-if="type !== '3' && tableData.length != 0"
              icon="el-icon-download"
              type="info"
              :loading="downloadLoading"
              @click="download"
            ></el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 筛选 -->
      <el-row>
        <el-col :span="24">
          <div style="height: 40px; line-height: 40px">
            <el-radio v-model="type" label="1" @change="changeRadio"
              >检测</el-radio
            >
            <el-radio v-model="type" label="2" @change="changeRadio"
              >检查</el-radio
            >
            <el-radio v-model="type" label="3" @change="changeRadio"
              >检测绩效</el-radio
            >
            <el-radio v-model="type" label="4" @change="changeRadio"
              >检查绩效</el-radio
            >
          </div>
        </el-col>
      </el-row>
      <!-- 筛选 -->

      <!-- 检测/检查工作量表格 -->
      <template v-if="type !== '3' && type !== '4' && type !== '5'">
        <el-table :data="tableData" border style="width: 100%" ref="table">
          <el-table-column
            v-for="(item, i) in column"
            :key="i"
            :prop="item.prop"
            :label="item.label"
            sortable
          >
          </el-table-column>
          <el-table-column
            v-for="(item, i) in columns"
            :key="i + 'i'"
            :prop="item.prop"
            :label="item.label"
            sortable
          >
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 50]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </template>

      <!-- 总绩效统计：月人均日检测检查工作量 & 月人均有效工作量 -->
      <div
        v-if="type === '5' && perfData.length > 0"
        style="
          background: #ecf5ff;
          border: 1px solid #b3d8ff;
          border-radius: 6px;
          padding: 14px 20px;
          margin-bottom: 16px;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 16px;
        "
      >
        <div style="display: flex; align-items: center">
          <span
            style="
              font-size: 15px;
              font-weight: bold;
              color: #409eff;
              margin-right: 12px;
            "
            >月人均日检测检查工作量</span
          >
          <span style="font-size: 13px; color: #606266">
            = 总当量之和（{{ Number(totalCheckInspectEquiv).toFixed(4) }}）/
            总工作人天数（{{ Number(totalWorkDaysSum).toFixed(4) }}）
          </span>
          <span
            style="
              font-size: 16px;
              font-weight: bold;
              color: #e6a23c;
              margin-left: 12px;
              background: #fdf6ec;
              padding: 2px 12px;
              border-radius: 4px;
            "
          >
            {{ Number(avgDailyCheckInspectEquiv).toFixed(4) }}
          </span>
        </div>
        <div style="display: flex; align-items: center">
          <span
            style="
              font-size: 15px;
              font-weight: bold;
              color: #409eff;
              margin-right: 12px;
            "
            >月人均有效工作量</span
          >
          <span style="font-size: 13px; color: #606266">
            = 有效工作量之和（{{ Number(totalEffectiveWorkload).toFixed(4) }}）/
            参与考核人数（{{ assessmentPersonCount }}）
          </span>
          <span
            style="
              font-size: 16px;
              font-weight: bold;
              color: #e6a23c;
              margin-left: 12px;
              background: #fdf6ec;
              padding: 2px 12px;
              border-radius: 4px;
            "
          >
            {{ Number(avgEffectiveWorkload).toFixed(4) }}
          </span>
        </div>
      </div>

      <!-- 检测/检查/总绩效表格 -->
      <el-table
        v-if="type === '3' || type === '4' || type === '5'"
        :data="perfData"
        border
        style="width: 100%"
      >
        <!-- 总绩效统计专用列 -->
        <template v-if="type === '5'">
          <el-table-column
            label="姓名"
            prop="personName"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column
            label="工作天数"
            prop="workDays"
            min-width="100"
            align="center"
          >
            <template slot-scope="scope">{{
            Number(scope.row.workDays).toFixed(0)
          }}</template>
          </el-table-column>
          <el-table-column label="检测当量数" min-width="120" align="center">
            <template slot-scope="scope">{{
              Number(scope.row.checkEquivalentUnits).toFixed(4)
            }}</template>
          </el-table-column>
          <el-table-column label="检查当量数" min-width="120" align="center">
            <template slot-scope="scope">{{
              Number(scope.row.inspectEquivalentUnits).toFixed(4)
            }}</template>
          </el-table-column>
          <el-table-column label="行程当量数" min-width="120" align="center">
            <template slot-scope="scope">{{
              Number(scope.row.mileageEquivalentUnits).toFixed(4)
            }}</template>
          </el-table-column>
          <el-table-column label="科技工作量" min-width="120" align="center">
            <template slot-scope="scope">{{
              Number(getTechWorkload(scope.row)).toFixed(4)
            }}</template>
          </el-table-column>
          <el-table-column label="总当量数" min-width="120" align="center">
            <template slot-scope="scope">{{
              Number(getTotalEquiv(scope.row)).toFixed(4)
            }}</template>
          </el-table-column>
          <el-table-column label="质量安全系数" min-width="120" align="center">
            <template slot-scope="scope">{{
              Number(scope.row.safetyCoefficient).toFixed(4)
            }}</template>
          </el-table-column>
          <el-table-column label="有效工作量" min-width="120" align="center">
            <template slot-scope="scope">{{
              Number(scope.row.effectiveWorkload).toFixed(4)
            }}</template>
          </el-table-column>
          <el-table-column label="工作量得分" min-width="110" align="center">
            <template slot-scope="scope">{{
              getWorkloadScore(scope.row)
            }}</template>
          </el-table-column>
          <el-table-column label="工作态度评分" min-width="130" align="center">
            <template slot-scope="scope">{{
              getAttitudeScore(scope.row)
            }}</template>
          </el-table-column>
          <el-table-column label="个人月绩效值" min-width="120" align="center">
            <template slot-scope="scope">{{
              getMonthlyPerformance(scope.row)
            }}</template>
          </el-table-column>
          <el-table-column label="绩效等级" min-width="90" align="center">
            <template slot-scope="scope">
              <span :style="getGradeStyle(scope.row)">{{
                getPerformanceGrade(scope.row)
              }}</span>
            </template>
          </el-table-column>
        </template>
        <!-- 检测/检查绩效通用列 -->
        <template v-if="type === '3' || type === '4'">
          <el-table-column
            label="姓名"
            prop="personName"
            width="100"
            align="center"
          ></el-table-column>
          <el-table-column label="天数" min-width="140" align="center">
            <template slot-scope="scope">
              <div class="perf-cell">
                <div class="perf-value">{{ scope.row.days }}</div>
                <div class="perf-avg">平均 {{ avgDays }}</div>
                <div :class="getDiffClass(scope.row.days, avgDays)">
                  {{ getDiffText(scope.row.days, avgDays) }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="项目数" min-width="140" align="center">
            <template slot-scope="scope">
              <div class="perf-cell">
                <div class="perf-value">{{ scope.row.projectCount }}</div>
                <div class="perf-avg">平均 {{ avgProjectCount }}</div>
                <div
                  :class="getDiffClass(scope.row.projectCount, avgProjectCount)"
                >
                  {{ getDiffText(scope.row.projectCount, avgProjectCount) }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="当量台数" min-width="160" align="center">
            <template slot-scope="scope">
              <div class="perf-cell">
                <div class="perf-value">{{ scope.row.equivalentUnits }}</div>
                <div class="perf-avg">平均 {{ avgEquivalentUnits }}</div>
                <div
                  :class="
                    getDiffClass(scope.row.equivalentUnits, avgEquivalentUnits)
                  "
                >
                  {{
                    getDiffText(scope.row.equivalentUnits, avgEquivalentUnits)
                  }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="工作时长/h" min-width="160" align="center">
            <template slot-scope="scope">
              <div class="perf-cell">
                <div class="perf-value">{{ scope.row.workHours }}</div>
                <div class="perf-avg">平均 {{ avgWorkHours }}</div>
                <div :class="getDiffClass(scope.row.workHours, avgWorkHours)">
                  {{ getDiffText(scope.row.workHours, avgWorkHours) }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="里程数/km" min-width="160" align="center">
            <template slot-scope="scope">
              <div class="perf-cell">
                <div class="perf-value">{{ scope.row.mileage }}</div>
                <div class="perf-avg">平均 {{ avgMileage }}</div>
                <div :class="getDiffClass(scope.row.mileage, avgMileage)">
                  {{ getDiffText(scope.row.mileage, avgMileage) }}
                </div>
              </div>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </el-card>
    <!-- card -->
  </div>
</template>

<script>
// import tableData from '~mock/users/history'
import fileDownload from 'js-file-download'
import {
  checkWorkload,
  workloadExport,
  queryPerfWorkload,
  queryInspectPerfWorkload,
  queryTotalPerfWorkload
} from '@/api/workload'
export default {
  components: {
    // TzTable
  },

  data() {
    return {
      downloadLoading: false,
      type: '1', //1检测，2检查，3检测绩效，4检查绩效，5总绩效统计
      offset: '', //当前起始位置（page-1）*limit
      page: 1, //当前页
      limit: '10', //
      total: '',
      pickerDate: [this.getLastMonthFirstDay(), this.getLastMonthLastDay()], //日期 默认上个月
      monthPicker: this.getLastMonthStr(), //月份选择（总绩效统计）
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ],
        disabledDate: (time) => {
          return time.getTime() > Date.now()
        }
      },

      // 表格固定列
      column: [
        {
          prop: 'submiterNo',
          label: '工号'
        },
        {
          label: '姓名',
          prop: 'submiterName'
        },
        {
          prop: 'type',
          label: '统计类型'
        },
        {
          prop: 'weights',
          label: '总工作量'
        },
        {
          prop: 'nomalweight',
          label: '正常工作量'
        },
        {
          prop: 'overTimeweight',
          label: '加班工作量'
        },
        {
          prop: 'applyweight',
          label: '申领工作量'
        },
        {
          prop: 'applyNumber',
          label: '检测单数'
        }
      ],
      // 表格动态列
      columns: [],
      // 工作量表格数据
      tableData: [],
      // 检测绩效数据
      perfData: [],
      avgDays: 0,
      avgProjectCount: 0,
      avgEquivalentUnits: 0,
      avgWorkHours: 0,
      avgMileage: 0,
      // 总绩效统计数据
      avgWorkDays: 0,
      avgCheckEquiv: 0,
      avgInspectEquiv: 0,
      avgMileageEquiv: 0,
      equipmentForm: {
        // name: '',
        // region: '',
        // date1: '',
        // date2: ''
      },
      formLabelWidth: '150px'
    }
  },
  computed: {
    // 页面标题
    pageTitle() {
      var titles = {
        1: '工作量统计',
        2: '工作量统计',
        3: '检测绩效',
        4: '检查绩效',
        5: '总绩效统计'
      }
      return titles[this.type] || '工作量统计'
    },
    // 月人均日检测检查工作量：所有个人(检测当量+检查当量)之和 / 总工作人天数
    totalCheckInspectEquiv() {
      if (!this.perfData || this.perfData.length === 0) return 0
      return this.perfData.reduce((sum, row) => {
        return (
          sum +
          (Number(row.checkEquivalentUnits) || 0) +
          (Number(row.inspectEquivalentUnits) || 0)
        )
      }, 0)
    },
    totalWorkDaysSum() {
      if (!this.perfData || this.perfData.length === 0) return 0
      return this.perfData.reduce((sum, row) => {
        return sum + (Number(row.workDays) || 0)
      }, 0)
    },
    avgDailyCheckInspectEquiv() {
      if (this.totalWorkDaysSum === 0) return '0.0000'
      var val = this.totalCheckInspectEquiv / this.totalWorkDaysSum
      return Math.floor(val * 10000) / 10000
    },
    // 总当量数平均值（含科技当量数）
    // = SUM(每个人(检测当量+检查当量+行程当量+科技当量)) / 人数
    avgTotalEquiv() {
      if (!this.perfData || this.perfData.length === 0) return 0
      var sum = 0
      var avgDaily = Number(this.avgDailyCheckInspectEquiv) || 0
      for (var i = 0; i < this.perfData.length; i++) {
        var row = this.perfData[i]
        var check = Number(row.checkEquivalentUnits) || 0
        var inspect = Number(row.inspectEquivalentUnits) || 0
        var mileage = Number(row.mileageEquivalentUnits) || 0
        var techDays = Number(row.techWorkDays) || 0
        var techWorkload = techDays * avgDaily
        sum += check + inspect + mileage + techWorkload
      }
      return Math.floor((sum / this.perfData.length) * 10000) / 10000
    },
    // 有效工作量之和（所有人的 effectiveWorkload 相加）
    totalEffectiveWorkload() {
      if (!this.perfData || this.perfData.length === 0) return 0
      var sum = 0
      for (var i = 0; i < this.perfData.length; i++) {
        sum += Number(this.perfData[i].effectiveWorkload) || 0
      }
      return sum
    },
    // 参与考核人数 = 工作天数 > 1 的人数
    assessmentPersonCount() {
      if (!this.perfData || this.perfData.length === 0) return 0
      var count = 0
      for (var i = 0; i < this.perfData.length; i++) {
        if (Number(this.perfData[i].workDays) > 1) {
          count++
        }
      }
      return count
    },
    // 月人均有效工作量 = 有效工作量之和 / 参与考核人数
    avgEffectiveWorkload() {
      if (this.assessmentPersonCount === 0) return 0
      var val = this.totalEffectiveWorkload / this.assessmentPersonCount
      return Math.floor(val * 10000) / 10000
    }
  },
  methods: {
    // 获取上个月第一天
    getLastMonthFirstDay() {
      let date = new Date()
      date.setDate(0)
      var y = date.getFullYear() //获取年份
      var m = date.getMonth() + 1 //获取月份
      m = m < 10 ? '0' + m : m //月份补 0
      return [y, m, '01'].join('-')
    },
    // 获取上个月最后一天
    getLastMonthLastDay() {
      let date = new Date()
      date.setDate(0)
      var y = date.getFullYear() //获取年份
      var m = date.getMonth() + 1 //获取月份
      var d = new Date(y, m, 0).getDate() //获取当月最后一日
      m = m < 10 ? '0' + m : m //月份补 0
      d = d < 10 ? '0' + d : d //日数补 0
      return [y, m, d].join('-')
    },
    // 获取上个月 yyyy-MM
    getLastMonthStr() {
      let date = new Date()
      date.setDate(0)
      var y = date.getFullYear()
      var m = date.getMonth() + 1
      m = m < 10 ? '0' + m : m
      return [y, m].join('-')
    },

    handleSizeChange(val) {
      this.limit = val
      this.listCheckWorkload()
    },
    handleCurrentChange(val) {
      this.page = val
      this.listCheckWorkload()
    },
    //选择日期事件
    handleDateChange(dialogPickerDate) {
      console.log(dialogPickerDate)
      if (dialogPickerDate == null) {
        this.pickerDate = []
      }
      this.page = 1
      if (this.type === '3') {
        this.listPerfWorkload()
      } else if (this.type === '4') {
        this.listInspectPerfWorkload()
      } else if (this.type === '5') {
        this.listTotalPerfWorkload()
      } else {
        this.listCheckWorkload()
      }
    },
    //选择月份事件（总绩效统计）
    handleMonthChange(val) {
      if (val == null) {
        this.monthPicker = this.getLastMonthStr()
      }
      this.listTotalPerfWorkload()
    },
    changeRadio() {
      this.page = 1
      if (this.type === '3') {
        this.listPerfWorkload()
      } else if (this.type === '4') {
        this.listInspectPerfWorkload()
      } else if (this.type === '5') {
        this.listTotalPerfWorkload()
      } else {
        this.listCheckWorkload()
      }
    },
    // 获取检测绩效数据
    // 人员过滤由后端 SQL 通过 t_members_wages 表处理，前端无需传 personIds
    listPerfWorkload() {
      var data = {
        startDt: this.pickerDate[0] || '',
        endDt: this.pickerDate[1] || ''
      }
      queryPerfWorkload(data).then((res) => {
        if (res.code == 200) {
          this.perfData = res.data.rows || []
          this.avgDays = res.data.avgDays || 0
          this.avgProjectCount = res.data.avgProjectCount || 0
          this.avgEquivalentUnits = res.data.avgEquivalentUnits || 0
          this.avgWorkHours = res.data.avgWorkHours || 0
          this.avgMileage = res.data.avgMileage || 0
        }
      })
    },
    // 获取检查绩效数据
    listInspectPerfWorkload() {
      var data = {
        startDt: this.pickerDate[0] || '',
        endDt: this.pickerDate[1] || ''
      }
      queryInspectPerfWorkload(data).then((res) => {
        if (res.code == 200) {
          this.perfData = res.data.rows || []
          this.avgDays = res.data.avgDays || 0
          this.avgProjectCount = res.data.avgProjectCount || 0
          this.avgEquivalentUnits = res.data.avgEquivalentUnits || 0
          this.avgWorkHours = res.data.avgWorkHours || 0
          this.avgMileage = res.data.avgMileage || 0
        }
      })
    },
    // 获取总绩效数据
    listTotalPerfWorkload() {
      var data = {
        reviewMonth: this.monthPicker || this.getLastMonthStr()
      }
      queryTotalPerfWorkload(data).then((res) => {
        if (res.code == 200) {
          this.perfData = res.data.rows || []
          // 按个人月绩效值从大到小排序
          this.sortPerfDataByPerformance()
          this.avgWorkDays = res.data.avgWorkDays || 0
          this.avgCheckEquiv = res.data.avgCheckEquiv || 0
          this.avgInspectEquiv = res.data.avgInspectEquiv || 0
          this.avgMileageEquiv = res.data.avgMileageEquiv || 0
          // avgTotalEquiv 由前端 computed 计算（含科技当量数）
          this.avgMileage = res.data.avgMileage || 0
        }
      })
    },
    // 计算与平均值的差值样式
    getDiffClass(value, avg) {
      var numVal = Number(value)
      var numAvg = Number(avg)
      if (numVal >= numAvg) {
        return 'diff-up'
      } else {
        return 'diff-down'
      }
    },
    // 计算与平均值的差值文本
    getDiffText(value, avg) {
      var numVal = Number(value)
      var numAvg = Number(avg)
      var diff = Math.abs(numVal - numAvg)
      if (numVal >= numAvg) {
        return '↑ +' + diff.toFixed(4)
      } else {
        return '↓ -' + diff.toFixed(4)
      }
    },
    // 计算个人的科技工作量 = 科技工作天数 × 月人均日检测检查工作量
    getTechWorkload(row) {
      var days = Number(row.techWorkDays) || 0
      if (
        days === 0 ||
        !this.avgDailyCheckInspectEquiv ||
        this.avgDailyCheckInspectEquiv === '0.0000'
      )
        return '0.0000'
      var val = days * Number(this.avgDailyCheckInspectEquiv)
      return Math.floor(val * 10000) / 10000
    },
    // 计算个人的总当量数 = 检测当量数 + 检查当量数 + 行程当量数 + 科技当量数
    getTotalEquiv(row) {
      var check = Number(row.checkEquivalentUnits) || 0
      var inspect = Number(row.inspectEquivalentUnits) || 0
      var mileage = Number(row.mileageEquivalentUnits) || 0
      var tech = Number(this.getTechWorkload(row)) || 0
      var val = check + inspect + mileage + tech
      return Math.floor(val * 10000) / 10000
    },
    // 计算个人工作量得分 = 个人月有效工作量 * 100 / 月人均有效工作量，最高不超过130
    getWorkloadScore(row) {
      var effective = Number(row.effectiveWorkload) || 0
      var avgEffective = Number(this.avgEffectiveWorkload) || 0
      if (effective === 0 || avgEffective === 0) return '0.0000'
      var score = (effective * 100) / avgEffective
      if (score > 130) score = 130
      return Math.floor(score * 10000) / 10000
    },
    // 计算个人工作态度评分 = 同事互评分(finalScore) * 40% + 客观纪律分(leaderScore) * 60%
    getAttitudeScore(row) {
      var finalScore = Number(row.finalScore) || 0
      var leaderScore = Number(row.leaderScore) || 0
      var score = finalScore * 0.4 + leaderScore * 0.6
      return Math.floor(score * 10000) / 10000
    },
    // 计算个人月绩效值 = 工作量得分 * 0.9 + 工作态度评分 * 0.1
    getMonthlyPerformance(row) {
      var workloadScore = Number(this.getWorkloadScore(row)) || 0
      var attitudeScore = Number(this.getAttitudeScore(row)) || 0
      var score = workloadScore * 0.9 + attitudeScore * 0.1
      return Math.floor(score * 10000) / 10000
    },
    // 按个人月绩效值从大到小排序
    sortPerfDataByPerformance() {
      var self = this
      this.perfData.sort(function (a, b) {
        var pa = Number(self.getMonthlyPerformance(a)) || 0
        var pb = Number(self.getMonthlyPerformance(b)) || 0
        return pb - pa
      })
    },
    // 获取绩效等级（基于排名百分比）
    // 优秀 ≤15% | 良好 ≤50% | 合格 ≤90% | 待改善 >90%
    getPerformanceGrade(row) {
      var total = this.perfData.length
      if (total === 0) return '-'
      // 找到当前行在排序后数组中的索引
      var idx = -1
      for (var i = 0; i < total; i++) {
        if (this.perfData[i] === row) {
          idx = i
          break
        }
      }
      if (idx === -1) return '-'
      var pct = ((idx + 1) / total) * 100
      if (pct <= 15) return '优秀'
      if (pct <= 50) return '良好'
      if (pct <= 90) return '合格'
      return '待改善'
    },
    // 获取绩效等级对应的样式（背景色+文字颜色）
    getGradeStyle(row) {
      var grade = this.getPerformanceGrade(row)
      var styles = {
        优秀: {
          background: '#f0f9eb',
          color: '#67c23a',
          fontWeight: 'bold',
          padding: '2px 8px',
          borderRadius: '4px',
          display: 'inline-block'
        },
        良好: {
          background: '#ecf5ff',
          color: '#409eff',
          fontWeight: 'bold',
          padding: '2px 8px',
          borderRadius: '4px',
          display: 'inline-block'
        },
        合格: {
          background: '#fdf6ec',
          color: '#e6a23c',
          fontWeight: 'bold',
          padding: '2px 8px',
          borderRadius: '4px',
          display: 'inline-block'
        },
        待改善: {
          background: '#fef0f0',
          color: '#f56c6c',
          fontWeight: 'bold',
          padding: '2px 8px',
          borderRadius: '4px',
          display: 'inline-block'
        }
      }
      return styles[grade] || {}
    },
    //获取工作量数据
    listCheckWorkload() {
      var data = {
        type: this.type,
        startDt: this.pickerDate[0] || '',
        endDt: this.pickerDate[1] || '',
        offset: (this.page - 1) * this.limit,
        limit: this.limit
      }
      // console.log(this.pickerDate, 'fdsfasdf')
      checkWorkload(data).then((res) => {
        console.log(res.data, '工作量')
        if (res.code == 402) {
          this.$message({
            message: res.data,
            duration: 4000
          })
        } else if (res.code == 200) {
          this.columns = []
          this.total = res.data.total
          this.tableData = res.data.rows
          this.equipmentForm = res.data.equipmentType
          res.data.equipmentType.forEach((element) => {
            let obj = {
              label: element.label,
              prop: element.label,
              value: element.value
            }
            this.columns.push(obj)
          })

          this.tableData.forEach((item) => {
            item.infos.forEach((ele) => {
              let obj1 = {}
              obj1[ele.deviceTypeName] = ele.count1
              Object.assign(item, obj1)
            })
          })
          console.log(this.tableData)
        }
      })
    },
    // 点击搜索
    search() {
      this.listCheckWorkload()
    },
    //弹窗确定
    sbmit() {
      console.log(this.radio)
    },
    //下载
    download() {
      this.downloadLoading = true
      var data = {
        startDt: this.pickerDate[0] || '',
        endDt: this.pickerDate[1] || '',
        type: this.type
      }
      workloadExport(data).then((res) => {
        fileDownload(res, '工作量统计.xlsx')
      })
      this.downloadLoading = false
    }
  },
  mounted() {
    this.listCheckWorkload()
  }
}
</script>

<style lang="scss" scoped>
.clearfix {
  display: flex;
  justify-content: space-between;
}
::v-deep .el-card__header {
  background: #ebf0f6;
}

.perf-cell {
  text-align: center;
  .perf-value {
    font-weight: bold;
    font-size: 15px;
  }
  .perf-avg {
    font-size: 12px;
    color: #909399;
    margin: 2px 0;
  }
}
.diff-up {
  color: #f56c6c;
  font-weight: bold;
  font-size: 13px;
}
.diff-down {
  color: #67c23a;
  font-weight: bold;
  font-size: 13px;
}
</style>
